import { template as template_87f0af165b7942cf91e3185cdcfcf51b } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_87f0af165b7942cf91e3185cdcfcf51b(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
